import PageWrapper from "Components/Pages/Wrapper";
import { LoadingText } from "Components/LoadingText";
import { Box } from "styles/globalComponents";
import { Button } from "Components/Button";
import { PREBUDGETSTATUS } from "Constants/PreBudget";
import { Container, ContentHolder } from "./styles";
import { DetailSection } from "./components/DetailSecation";
import { useViewDetails } from "./hooks/useViewOrderModal";
import { CancelOrderModal } from "./components/CancelOrderModal c";
import { CancelPreOrderModal } from "./components/CancelPreOrderModal";
import { RescheduleModal } from "./components/RescheduleModal";

export const PreBudgetDetails = () => {
  let budget_id = null;
  let zipcode = "";
  let acuity_id = null;
  let client;

  const {
    preOderDetailsAPI,
    preOrderDetails,
    preOrderAddressDetails,
    openModalSecondary,
    modals,
    closeSecondaryModal,
    preOrderPatientDetails,
  } = useViewDetails();

  if (preOderDetailsAPI.isLoading) {
    return (
      <PageWrapper className="entry-app-content">
        <ContentHolder>
          <Container>
            <LoadingText text="Carregando detalhamento do pré-orçamento. Aguarde!" />
          </Container>
        </ContentHolder>
      </PageWrapper>
    );
  }

  if (preOderDetailsAPI.error) {
    return (
      <PageWrapper className="entry-app-content">
        <ContentHolder>
          <Container>
            <Box mt="120" display="flex" justify="center">
              <h3 className="text-center">
                Este pré-orçamento está bloqueado para edição no momento!
              </h3>
            </Box>
          </Container>
        </ContentHolder>
      </PageWrapper>
    );
  }

  if (!preOderDetailsAPI.data) return null;

  if (preOderDetailsAPI.data.budget_id) {
    budget_id = preOderDetailsAPI.data.budget_id;
  }

  if (preOderDetailsAPI.data.address.zipcode) {
    zipcode = preOderDetailsAPI.data.address.zipcode;
  }

  if (preOderDetailsAPI.data.client) {
    client = preOderDetailsAPI.data.client;
  }

  if (preOderDetailsAPI.data.acuity_id) {
    acuity_id = preOderDetailsAPI.data.acuity_id;
  }

  const { id } = preOderDetailsAPI.data;
  const errorMessage = preOderDetailsAPI.error;

  return (
    <PageWrapper className="entry-app-content">
      <ContentHolder>
        <Container>
          {errorMessage ? (
            <p>A edição deste pré-orçamento está bloqueada no momento</p>
          ) : (
            <>
              <div className="heading">
                <h3>Detalhes do pré-orçamento</h3>
              </div>

              <DetailSection
                sectionTitle="Dados do paciente"
                fields={preOrderPatientDetails}
              />

              <div className="separator" />

              <DetailSection
                sectionTitle="Dados do pré-orçamento"
                fields={preOrderDetails}
              />

              <div className="separator" />

              <div className="separator" />

              <DetailSection
                sectionTitle="Dados do endereço"
                fields={preOrderAddressDetails}
              />
            </>
          )}

          <Box display="flex" justify="center" mt="30">
            {acuity_id && (
              <Button onClick={() => openModalSecondary("schedule")}>
                Alterar agendamento
              </Button>
            )}

            {acuity_id && (
              <Button
                classButton="danger"
                onClick={() => openModalSecondary("cancelOrderModal")}
              >
                Cancelar agendamento
              </Button>
            )}

            {preOderDetailsAPI.data.status.id !== PREBUDGETSTATUS.canceled ? (
              <Button
                classButton="danger"
                onClick={() => openModalSecondary("cancelPreOrderModal")}
              >
                Cancelar pré-orçamento
              </Button>
            ) : null}
          </Box>
        </Container>
      </ContentHolder>

      {modals.cancelOrderModal && acuity_id && (
        <CancelOrderModal
          acuityId={acuity_id}
          isOpen={modals.cancelOrderModal}
          refetch={preOderDetailsAPI.refetch}
          requestClose={closeSecondaryModal}
        />
      )}

      {modals.cancelPreOrderModal && id && (
        <CancelPreOrderModal
          acuityId={id}
          isOpen={modals.cancelPreOrderModal}
          refetch={preOderDetailsAPI.refetch}
          requestClose={closeSecondaryModal}
        />
      )}

      {modals.schedule && client && (
        <RescheduleModal
          acuityId={acuity_id}
          isOpen={modals.schedule}
          refetch={preOderDetailsAPI.refetch}
          requestClose={closeSecondaryModal}
          zipcode={zipcode}
          client={client}
          preOrderId={id}
          personData={preOderDetailsAPI.data}
        />
      )}
    </PageWrapper>
  );
};
